const storedUser = JSON.parse(localStorage.getItem("user")) || {};

const generateMenu = () => {
  const baseMenu = [
    { 
      path: "dashboard",
      icon: "fa fa-sitemap",
      title: "Tableau de bord",
      children: [{ path: "/dashboard/v1", title: "Graphiques" }],
    },
  ];

  if (storedUser?.usertype === 1) {
    return [
      ...baseMenu,
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Saisie de la progression",
        children: [{ path: "/Raportee/dataentry", title: "Collecte de données" }, 
        { path: "/Raportee/dataedit", title: "Liste des données" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports",
        children: [
          { path: "Raportee",title: "Internes",  children: [
            { path: "/Raportee/interne", title: "Niveau central" },
            {path: "/Raportee/interneregional", title: "Niveau régional" }]},
          { path: "/Raportee/externe", title: "Externes" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports prédéfinis",
        children: [{ path: "/Raportee/predefined", title: "Liste des rapports" }],
      },
      {
        path: "Administration",
        icon: "fa fa-microchip",
        title: "Administration",
        children: [{ path: "/Administration/usermanage", title: "Gérer les utilisateurs" },
          { path: "/Administration/comp_user_rapport", title: "État de collecte des données" },
          { path: "/Administration/report_user_rapport", title: "État de chargement des rapports" },
          { path: "/Administration/tableu_de_suivi_composants", title: "Tableau de suivi Composants" },
          { path: "/Administration/tableu_de_suivi_rapports", title: "Tableau de suivi Rapports" }],
      },
    ];
  } else if (storedUser?.usertype === 2) {
    return [
      ...baseMenu,
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Saisie de la progression",
        children: [{ path: "/Raportee/dataentry", title: "Collecte de données" }, 
        { path: "/Raportee/dataedit", title: "Liste des données" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports",
        children: [
          { path: "Raportee",title: "Internes",  children: [
            { path: "/Raportee/interne", title: "Niveau central" },
            {path: "/Raportee/interneregional", title: "Niveau régional" }]},
          { path: "/Raportee/externe", title: "Externes" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports prédéfinis",
        children: [{ path: "/Raportee/predefined", title: "Liste des rapports" }],
      }
    ];
  }
  else if (storedUser?.usertype === 3) {
    return [
      ...baseMenu,
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Saisie de la progression",
        children: [ 
        { path: "/Raportee/dataedit", title: "Liste des données" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports",
        children: [
          { path: "Raportee",title: "Internes",  children: [
            { path: "/Raportee/interne", title: "Niveau central" },
            {path: "/Raportee/interneregional", title: "Niveau régional" }]},
          { path: "/Raportee/externe", title: "Externes" }],
      },
      {
        path: "Raportee",
        icon: "fa fa-microchip",
        title: "Rapports prédéfinis",
        children: [{ path: "/Raportee/predefined", title: "Liste des rapports" }],
      }
    ];
  }

  return baseMenu; // Default menu if no user type is found
};

const Menu = generateMenu();

export default Menu;